import { useSelector } from "react-redux";
import type { RootState } from "@src/reducers/store";

export const useIsDrBoyNamespace = (): boolean => {
  const namespace = useSelector(
    (state: RootState) => state.yourSlice.authContext?.customerNamespace,
  );
  if (namespace) {
    return namespace === "62061c5d-479e-4ab0-b5be-7d7aca41fad3";
  }
  return false;
};
